<template>
    <div class="tab-content">
        <div class="settings-container">
            <div class="line">
                <span class="tit">키오스크 결제 알림 수신자</span>
                <p class="desc">
                    대표관리자를 포함해 키오스크 결제 알림을 받을 직원을 선택하세요.
                </p>
            </div>

            <loading-spinner v-if="isLoading" :height="220"></loading-spinner>

            <template v-else>
                <p v-if="!hasRepresentativeAdmin" class="warn">
                    대표관리자 권한 직원이 없습니다. 권한 설정을 확인해 주세요.
                </p>

                <table class="com-table recipient-table">
                    <colgroup>
                        <col style="width: 260px" />
                        <col style="width: 260px" />
                        <col style="width: 180px" />
                        <col />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>직원명</th>
                            <th>권한</th>
                            <th>수신 여부</th>
                            <th>상태</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="recipient in recipients" :key="recipient.staffId">
                            <td>{{ recipient.name }}</td>
                            <td>{{ recipient.roleName || '-' }}</td>
                            <td>
                                <div class="com-design-check">
                                    <input
                                        :id="`kiosk-payment-notification-${recipient.staffId}`"
                                        :checked="recipient.kioskPaymentNotificationYn"
                                        :disabled="isSaving"
                                        type="checkbox"
                                        @change="onToggle(recipient, $event.target.checked)"
                                    />
                                    <label :for="`kiosk-payment-notification-${recipient.staffId}`"></label>
                                </div>
                            </td>
                            <td>{{ recipient.kioskPaymentNotificationYn ? '수신' : '-' }}</td>
                        </tr>
                        <tr v-if="recipients.length === 0">
                            <td colspan="4">재직 직원이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>

                <div class="bottom-btn">
                    <button :disabled="isLoading || isSaving" class="com-btn" type="button" @click="loadRecipients">
                        취소
                    </button>
                    <button :disabled="isLoading || isSaving" class="com-btn blue" type="button" @click="saveRecipients">
                        저장
                    </button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

import api from '@/assets/js/api';
import LoadingSpinner from '@/components/LoadingSpinner.vue';

export default {
    name: 'PaymentNotificationRecipients',

    components: {
        LoadingSpinner,
    },

    data() {
        return {
            isLoading: false,
            isSaving: false,
            recipients: [],
        };
    },

    computed: {
        ...mapState({
            centerId: (state) => state.auth.user.centerId,
        }),

        hasRepresentativeAdmin() {
            return this.recipients.some((recipient) => recipient.isRepresentativeAdmin);
        },
    },

    mounted() {
        this.loadRecipients();
    },

    methods: {
        async loadRecipients() {
            if (this.isLoading) return;

            this.isLoading = true;

            try {
                const { data } = await api.get(
                    `/admin/api/center/${this.centerId}/kiosk/payment-notification-recipients?replaceAllRecipients=true`
                );

                this.recipients = Array.isArray(data) ? data : (data && data.recipients) || [];
            } catch (e) {
                console.error(e);
                alert('로딩에 실패하였습니다.');
            } finally {
                this.isLoading = false;
            }
        },

        onToggle(recipient, checked) {
            recipient.kioskPaymentNotificationYn = checked;
        },

        async saveRecipients() {
            if (this.isLoading || this.isSaving) return;

            this.isSaving = true;

            const staffIds = this.recipients
                .filter((recipient) => recipient.kioskPaymentNotificationYn)
                .map((recipient) => recipient.staffId);

            try {
                await api.put(`/admin/api/center/${this.centerId}/kiosk/payment-notification-recipients`, {
                    staffIds,
                    replaceAllRecipients: true,
                });

                alert('저장했습니다.');
                await this.loadRecipients();
            } catch (e) {
                console.error(e);
                alert('저장에 실패했습니다.');
            } finally {
                this.isSaving = false;
            }
        },
    },
};
</script>

<style scoped>
.settings-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-left: 40px;
    padding-right: 40px;
}

.line {
    margin-top: 24px;
}

.tit {
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    color: #333;
}

.desc {
    margin-top: 6px;
    margin-bottom: 0;
    font-size: 14px;
    color: #666;
}

.warn {
    margin: 16px 0 0;
    color: #f5475b;
}

.recipient-table {
    margin-top: 16px;
}
</style>
